module.exports = __webpack_public_path__ + "img/ceramic-blue.a5e1cd9c.webp";